import React, { useState } from 'react';
import { Outlet, useLocation, useMatch } from 'react-router-dom';
import Sidebar from './Sidebar';

const TITLES = {
  '/dashboard':'/dashboard','/tutorials':'/tutorials',
  '/creator-videos':'/creator-videos','/blog-videos':'/blog-videos',
  '/batches':'/batches','/schools':'/schools','/orders':'/orders',
  '/users':'/users','/roles':'/roles',
  '/masters/academic-years':'/masters/academic-years',
  '/masters/districts':'/masters/districts',
  '/masters/pincodes':'/masters/pincodes',
};
const LABELS = {
  '/dashboard':'Dashboard','/tutorials':'Tutorials',
  '/creator-videos':'Creator Videos','/blog-videos':'Blog Videos',
  '/batches':'Batches','/schools':'Schools','/orders':'Orders',
  '/users':'Users','/roles':'Roles & Permissions',
  '/masters/academic-years':'Academic Years',
  '/masters/districts':'Districts',
  '/masters/pincodes':'Pincodes',
};

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const { pathname } = useLocation();
  const chapterMatch = useMatch('/tutorials/:id/chapters');

  const title = chapterMatch ? 'Chapters' : (LABELS[pathname] || 'Swardhara');
  const sub   = chapterMatch ? 'Tutorial content' : '';

  return (
    <div className="app-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(v=>!v)} />
      <div className={`main-content ${collapsed?'collapsed':''}`}>
        <header className="main-header">
          <div className="header-left">
            <div className="header-breadcrumb">
              Swardhara &rsaquo; <strong>{title}</strong>
              {sub && <span style={{color:'var(--grey-300)'}}> · {sub}</span>}
            </div>
          </div>
        </header>
        <div className="page-body"><Outlet /></div>
      </div>
    </div>
  );
}
